// extracted by mini-css-extract-plugin
module.exports = {"App":"_2MqrEPH7wRGTUnAVXplCQU","title":"_24SQRvaGQXqT_X5Wyx2Ndf","subtitle":"m60etY5PtB6SdZqnydOx6","button":"_36HiqEt255U7c_x1fj-oiL"};